// @ts-nocheck
import capitalize from 'utils/capitalise';
import RandomWords from 'random-words';

import {
  ASSESSMENT_LIST_VIEW,
  BAR_CHART,
  PIE_CHART,
  LINE_CHART,
} from './constants';

const getRandomWord = () => capitalize(RandomWords());

export const mockAssessmentData = (definition) => {
  switch (definition.type) {
    case ASSESSMENT_LIST_VIEW:
      return {
        columns: definition.columns.map((column) => ({
          label: column.label,
          userLabel: column.userLabel,
        })),
        data: Array.from(new Array(5)).map(() => {
          const fields = {};
          definition.columns.forEach((col) => {
            fields[col.label] = {
              type: 'string',
              value: getRandomWord(),
            };
          });
          return {
            fields,
            metadata: {},
          };
        }),
      };

    case LINE_CHART:
    case BAR_CHART:
      if (definition.groupBy.levels.length > 1) {
        return {
          groupBy: {
            data: {
              groupByData: [
                {
                  data: [
                    {
                      value: getRandomWord(),
                      prefix: '',
                      data: [
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 6, prefix: '', data: null }],
                        },
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 5, prefix: '', data: null }],
                        },
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 2, prefix: '', data: null }],
                        },
                      ],
                    },
                    {
                      value: getRandomWord(),
                      prefix: '',
                      data: [
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 3, prefix: '', data: null }],
                        },
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 7, prefix: '', data: null }],
                        },
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 1, prefix: '', data: null }],
                        },
                      ],
                    },
                    {
                      value: getRandomWord(),
                      prefix: '',
                      data: [
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 4, prefix: '', data: null }],
                        },
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 5, prefix: '', data: null }],
                        },
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 2, prefix: '', data: null }],
                        },
                      ],
                    },
                    {
                      value: getRandomWord(),
                      prefix: '',
                      data: [
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 6, prefix: '', data: null }],
                        },
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 4, prefix: '', data: null }],
                        },
                        {
                          value: getRandomWord(),
                          prefix: '',
                          data: [{ value: 3, prefix: '', data: null }],
                        },
                      ],
                    },
                  ],
                  prefix: '',
                  value: 'root',
                },
              ],
              noOfDimensions: 2,
            },
            levels: definition.groupBy.levels,
          },
          measure: {
            functions: definition.measure.functions,
          },
          barPosition: definition.barPosition,
        };
      }
      return {
        groupBy: {
          data: {
            groupByData: [
              {
                data: [
                  {
                    value: getRandomWord(),
                    prefix: '',
                    data: [{ value: 3, prefix: '', data: null }],
                  },
                  {
                    value: getRandomWord(),
                    prefix: '',
                    data: [{ value: 5, prefix: '', data: null }],
                  },
                  {
                    value: getRandomWord(),
                    prefix: '',
                    data: [{ value: 8, prefix: '', data: null }],
                  },
                  {
                    value: getRandomWord(),
                    prefix: '',
                    data: [{ value: 1, prefix: '', data: null }],
                  },
                ],
                prefix: '',
                value: 'root',
              },
            ],
            noOfDimensions: 1,
          },
          levels: definition.groupBy.levels,
        },
        measure: {
          functions: definition.measure.functions,
        },
        barPosition: definition.barPosition,
      };

    case PIE_CHART:
      return {
        groupBy: {
          data: {
            groupByData: [
              {
                data: [
                  {
                    value: getRandomWord(),
                    prefix: '',
                    data: [{ value: 3, prefix: '', data: null }],
                  },
                  {
                    value: getRandomWord(),
                    prefix: '',
                    data: [{ value: 5, prefix: '', data: null }],
                  },
                  {
                    value: getRandomWord(),
                    prefix: '',
                    data: [{ value: 4, prefix: '', data: null }],
                  },
                  {
                    value: getRandomWord(),
                    prefix: '',
                    data: [{ value: 2, prefix: '', data: null }],
                  },
                ],
                prefix: '',
                value: 'root',
              },
            ],
            noOfDimensions: 1,
          },
          levels: definition.groupBy.levels,
        },
      };

    default:
      return {
        data: [],
      };
  }
};

const mockResponse = (definition: unknown) => ({
  status: 200,
  data: {
    result: mockAssessmentData(definition),
  },
});

const mockWidgetPreviewAPI = ({ definition }: { definition: unknown }) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockResponse(definition));
    }, 250);
  });

export { mockWidgetPreviewAPI };
